import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ApiKeysInterface } from '../../../models/dashboard/configuration/api-key.model';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { useAppSelector } from '../../../redux/store';
import useHttps from '../../useHttps';

const useGetNewApiKeys = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [newPlainKeyValue, setNewPlainKeyValue] = useState('');
  const { businessInfo } = useAppSelector((state) => state.businessInfoData);

  const onGetNewApiKeysError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ?? 'Something went wrong while generating new keys'
    );
  };

  const onGetNewApiKeysSuccess = (callback: () => void) => ({
    data,
    message,
  }: SuccessHttpResponse<ApiKeysInterface>) => {
    setNewPlainKeyValue(data?.plainKey ?? '');
    callback();
  };

  const getNewApiKeys = (callback: () => void) => {
    const targetEnvironment = businessInfo?.isTestMode ? 'Test' : 'Live';
    const url: HttpConfig = {
      url: `api/v1/api-key/${targetEnvironment.toLowerCase()}`,
      method: 'post',
    };

    request(url, onGetNewApiKeysSuccess(callback), setLoading, onGetNewApiKeysError);
  };

  return { getNewApiKeys, newPlainKeyValue, loading };
};

export default useGetNewApiKeys;
